const ANIMATION_DURATION = 400;

export const smoothScroll = (href) => {
  const id = href.replace('#', '');
  const focusElement = document.getElementById(id);
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

  document.documentElement.style.scrollBehavior = 'smooth';

  window.scrollTo(0, focusElement.getBoundingClientRect().top + scrollTop);
};

export const animatedSmoothScroll = async (id, initialScroll, scrollOffset) => {
  const scrollElement = document.scrollingElement || document.documentElement;
  scrollElement.scrollTop = initialScroll;
  const focusElement = document.getElementById(id);
  const top = focusElement.getBoundingClientRect().top;
  step(Date.now(), initialScroll, top + initialScroll - scrollOffset);
};

const step = (startTime, startY, finalY) => {
  const timeElapsed = Date.now() - startTime;
  const scrollElement = document.scrollingElement || document.documentElement;
  if (timeElapsed < ANIMATION_DURATION) {
    scrollElement.scrollTop =
      startY + (finalY - startY) * ease(timeElapsed / ANIMATION_DURATION);
    window.requestAnimationFrame(step.bind(this, startTime, startY, finalY));
  } else {
    scrollElement.scrollTop = finalY;
  }
};

const ease = (elapsed) => {
  return 0.5 * (1 - Math.cos(Math.PI * elapsed));
};
